/**
 * Collection description: three lines, then an inline Read more.
 *
 * The first attempt clamped the box with max-height and pinned the button to bottom-right. That
 * puts the link at the CONTAINER edge, not at the end of the sentence, so on a short final line
 * it floats away on its own with a gap in between.
 *
 * The only way to get it genuinely after the text is to shorten the text. This measures how many
 * words fit into three lines with the button alongside, truncates there, and puts the button in
 * the normal flow immediately after. No overflow hidden, so nothing is clipped and there is no
 * fade to disguise a cut.
 */
(function () {
  function init() {
    document.querySelectorAll('.collection-hero__description.rte').forEach(function (el) {
      if (el.dataset.clampReady) return;
      el.dataset.clampReady = 'true';

      var fullHtml = el.innerHTML;
      var firstP = el.querySelector('p');
      if (!firstP) return;

      var fullText = firstP.textContent.trim();
      var lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 24;
      var maxHeight = lineHeight * 3 + 2;

      // Nothing to hide: leave it alone rather than adding a pointless toggle.
      if (el.scrollHeight <= maxHeight) return;

      // Strip trailing punctuation before the ellipsis, or a sentence already ending in a full
      // stop renders as "you only like one.\u2026".
      function trim(t) {
        return t.replace(/[\s.,;:!?]+$/, '');
      }

      function button(label, expanded) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'collection-description-toggle';
        b.textContent = label;
        b.setAttribute('aria-expanded', String(expanded));
        b.addEventListener('click', expanded ? collapse : expand);
        return b;
      }

      function expand() {
        el.innerHTML = fullHtml;
        var last = el.querySelector('p:last-of-type') || el;
        last.appendChild(document.createTextNode(' '));
        last.appendChild(button('Read less', true));
      }

      function collapse() {
        el.innerHTML = '<p></p>';
        var p = el.querySelector('p');
        var words = fullText.split(/\s+/);

        // Largest word count that still fits in three lines with the button on the end.
        var lo = 1;
        var hi = words.length;
        var best = 1;
        while (lo <= hi) {
          var mid = (lo + hi) >> 1;
          p.textContent = trim(words.slice(0, mid).join(' ')) + '… ';
          p.appendChild(button('Read more', false));
          if (el.scrollHeight <= maxHeight) {
            best = mid;
            lo = mid + 1;
          } else {
            hi = mid - 1;
          }
        }
        p.textContent = trim(words.slice(0, best).join(' ')) + '… ';
        p.appendChild(button('Read more', false));
      }

      collapse();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
